import React, { VFC } from 'react';
import T from 'i18n-react';
import { useTheme } from '@material-ui/core/styles';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

// js codes
import { ROOMS } from '../../../routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const ChatIconLink: VFC<Props> = (props: Props) => {
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={ROOMS}>
        <IconWithWord Icon={ChatIcon} word={T.translate('header.menu.chat')} />
      </IconLink>
    </IconWrapper>
  );
};

export default ChatIconLink;
